import { render } from "./LogoutHome.vue?vue&type=template&id=16c2300c&scoped=true"
import script from "./LogoutHome.vue?vue&type=script&lang=js"
export * from "./LogoutHome.vue?vue&type=script&lang=js"

import "./LogoutHome.vue?vue&type=style&index=0&id=16c2300c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c2300c"]])

export default __exports__